import HC from "@material-ui/icons/HomeOutlined";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useBreadcrumbsHomeIconStyles = makeThemedStyles(
  "Breadcrumbs.HomeIcon",
  (theme) => ({
    root: {
      width: "20px",
      height: "20px",
      color: "rgba(255, 255, 255, 0.5)",
      "&:hover": { color: "rgba(255, 255, 255, 0.8)" },
    },
  })
);

const HomeIcon = () => {
  const classes: any = useBreadcrumbsHomeIconStyles();
  const { HomeIcon, ...other } = classes;
  return <HC classes={other} />;
};

export default HomeIcon;
